import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { axios } from 'lib'
import { PaginatedParams, PaginatedResponse } from 'services/api/types'
import { OrderSellers } from 'modules/orders/types'

const loadOrderIndicators = (
  params: PaginatedParams
): PaginatedResponse<OrderSellers> => {
  const { page = 1, limit = 10 } = params

  return axios.get('/orders/indicators', {
    params: {
      page,
      limit,
      ...params
    }
  })
}

export function useLoadOrderIndicators(params: PaginatedParams) {
  return useQuery(
    ['orderIndicators', params],
    () => loadOrderIndicators(params),
    {
      keepPreviousData: true,
      onError: () =>
        toast.error('Não foi possível carregar indicadores', {
          toastId: 'loadOrderIndicators'
        })
    }
  )
}
